import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_Verify_your_identity_within_N0_ELL,
  TXTWCL_YouXre_currently_using_a_unver_ELL,
  TXTWCL_Your_details_have_been_savedX
} from './RO.messages.json';

const RO: React.FC = () => (
  <Typography>
    <Translation {...TXTWCL_Your_details_have_been_savedX} />{' '}
    <Translation {...TXTWCL_YouXre_currently_using_a_unver_ELL} />{' '}
    <Translation values={{ 0: 30 }} {...TXTWCL_Verify_your_identity_within_N0_ELL} />
  </Typography>
);

export default RO;
